import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ContactDialogComponent } from '../contact-dialog/contact-dialog.component';

@Component({
  selector: 'app-footer',
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    MatIconModule,
    MatDividerModule,
    MatButtonModule,
    MatDialogModule
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  standalone: true
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
  supportEmail = 'support@ezat.work';
  showBackToTop = false;

  socialLinks: { name: string; icon: string; url: string }[] = [
    { name: 'X / Twitter', icon: '𝕏', url: 'https://x.com/EzatWork' },
    { name: 'LinkedIn',    icon: 'in', url: 'https://www.linkedin.com/company/ezatwork' },
  ];

  constructor(private dialog: MatDialog) {}

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.showBackToTop = window.scrollY > 300;
  }

  openContactDialog(): void {
    this.dialog.open(ContactDialogComponent, {
      panelClass: 'contact-dialog-panel',
      maxWidth: '90vw',
      autoFocus: false
    });
  }

  scrollToTop(): void {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}
